import { useState, useEffect } from 'react';
import { OIDCTokenSet, OIDCClient } from 'infrastructure/oidc/OIDCClient';

export function useOIDCTokenSet(oidcClient: OIDCClient | null) {
    const [tokenSet, setTokenSet] = useState<OIDCTokenSet | null>(null);

    useEffect(() => {
        if (!oidcClient) return;

        const listener = () => setTokenSet(oidcClient.tokenSet);
        listener();
        oidcClient.addTokenSetListener(listener);

        return () => oidcClient.removeTokenSetListener(listener);
    }, [oidcClient]);

    return tokenSet;
}
